import Article from 'ui/Element/List/Item/Cell/Article/Information'
import ServiceItem from 'ui/Element/List/Item/Cell/ServiceItem/Information'
import Request from 'ui/Element/List/Item/Cell/Request/Information'
import Organisation from 'ui/Element/List/Item/Cell/Organisation/Information'
import Person from 'ui/Element/List/Item/Cell/Person/Information'
import Equipment from 'ui/Element/List/Item/Cell/Equipment/Information'
import Documentation from 'ui/Element/List/Item/Cell/Documentation/Information'

/**
 * Displays the appropriate list item based on the incoming `type`.
 *
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellDashboardName = (props) => {
  const {
    meta: { type: metaType = null } = {},
    docType = null,
  } = props || {}

  const type = metaType || docType

  return (
    <>
      {type === 'article' && (<Article {...props} />)}
      {type === 'equipment' && (<Equipment {...props} />)}
      {type === 'docChunk' && (<Documentation {...props} />)}
      {type === 'documentation' && (<Documentation {...props} />)}

      {type === 'serviceitem' && (<ServiceItem {...props} />)}
      {type === 'request' && (<Request {...props} />)}
      {type === 'organisation' && (<Organisation {...props} />)}
      {type === 'person' && (<Person {...props} />)}
    </>
  )
}

export default ListItemCellDashboardName
